import Service from '@ember/service';
import { AcknowledgeSubscriptionRequest, GetExperimentVariationRequest, GetSubscriptionRequest, UpdateSubscriptionRequest } from '@square/dashboard-protos/models/squareup/appointments/api/external_service';
import ExternalAppointmentsClient from '@square/dashboard-data/clients/external-appointments';

// https://prototype.sqprod.co/#/docs/squareup.appointments.api.ExternalAppointmentsService
export default class ExternalAppointmentsService extends Service {
  getSubscription(properties) {
    const request = GetSubscriptionRequest.create(properties);
    return ExternalAppointmentsClient.getSubscription(request);
  }
  updateSubscription(properties) {
    const request = UpdateSubscriptionRequest.create(properties);
    return ExternalAppointmentsClient.updateSubscription(request);
  }
  acknowledgeSubscription(properties) {
    const request = AcknowledgeSubscriptionRequest.create(properties);
    return ExternalAppointmentsClient.acknowledgeSubscription(request);
  }
  getExperimentVariation(properties) {
    const request = GetExperimentVariationRequest.create(properties);
    return ExternalAppointmentsClient.getExperimentVariation(request);
  }
}